import {
	mdiAccountAlertOutline,
	mdiAccountGroup,
	mdiAlert,
	mdiAlertCircle,
	mdiAlertCircleOutline,
	mdiArrowCollapse,
	mdiArrowExpand,
	mdiArrowExpandHorizontal,
	mdiArrowLeft,
	mdiArrowRight,
	mdiChat,
	mdiCalendarOutline,
	mdiCheck,
	mdiCheckCircle,
	mdiCheckCircleOutline,
	mdiChevronDown,
	mdiChevronLeft,
	mdiChevronRight,
	mdiClose,
	mdiCloseCircleOutline,
	mdiCloudOff,
	mdiCodeTags,
	mdiCog,
	mdiConnection,
	mdiContentCopy,
	mdiCreation,
	mdiDatabase,
	mdiDeleteOutline,
	mdiDotsVertical,
	mdiDownload,
	mdiDragVertical,
	mdiEarth,
	mdiEmailCheckOutline,
	mdiEmailOutline,
	mdiEye,
	mdiEyeOff,
	mdiImage,
	mdiFacebook,
	mdiFileChartOutline,
	mdiFileDelimited,
	mdiFileDocumentOutline,
	mdiFilePdfBox,
	mdiFileWordBox,
	mdiFormTextbox,
	mdiFormatBold,
	mdiFormatItalic,
	mdiFormatListBulleted,
	mdiFormatListChecks,
	mdiFormatListNumbered,
	mdiFormatQuoteClose,
	mdiFormatUnderline,
	mdiHistory,
	mdiImageOutline,
	mdiImageSizeSelectActual,
	mdiInstagram,
	mdiLinkedin,
	mdiLinkVariant,
	mdiLock,
	mdiMagnify,
	mdiMagnifyPlusOutline,
	mdiMessageTextOutline,
	mdiMicrosoftExcel,
	mdiMinusCircleOutline,
	mdiPackageVariant,
	mdiPackageVariantRemove,
	mdiPencil,
	mdiPhoneOutline,
	mdiPlayCircleOutline,
	mdiPlus,
	mdiPlusCircle,
	mdiPrinter,
	mdiRedo,
	mdiRefresh,
	mdiSort,
	mdiStar,
	mdiStarOutline,
	mdiSync,
	mdiTagOutline,
	mdiTableColumnPlusAfter,
	mdiTableColumnRemove,
	mdiTablePlus,
	mdiTimerSand,
	mdiTranslate,
	mdiTableRowPlusAfter,
	mdiTableRowRemove,
	mdiTrashCanOutline,
	mdiUndo,
	mdiCrosshairsGps,
	mdiMapMarker,
	mdiMapMarkerOutline,
	mdiAccountOutline,
	mdiVideoOutline,
	mdiViewGrid,
	mdiShareVariant,
	mdiImageMultiple,
	mdiMusicNote,
	mdiOpenInNew,
	mdiTwitter,
	mdiWeb,
	mdiYoutube
} from "@mdi/js";

/** Tap-to-measure's lightbox button. Not an MDI glyph: drawn in the outline style of the LiveSwitch
 * icon font's `-stroke` icons (2px line filling the 24px grid) that share its toolbar, which has no
 * ruler. A filled path (outline minus inner rect, plus ticks) so the mdi iconset renders it like any
 * other entry here, in `currentColor`. */
const measureStroke =
	"M2.03 15.96 L15.96 2.03 L17.94 2.03 L21.97 6.06 L21.97 8.04 L8.04 21.97 L6.06 21.97 L2.03 17.94 Z M4.15 17.23 L6.77 19.85 L7.33 19.85 L19.85 7.33 L19.85 6.77 L17.23 4.15 L16.67 4.15 L4.15 16.67 Z M5.98 14.82 L7.40 13.41 L8.89 14.90 L7.47 16.31 Z M9.69 11.11 L11.11 9.69 L13.24 11.82 L11.82 13.24 Z M13.41 7.40 L14.82 5.98 L16.31 7.47 L14.90 8.89 Z";

export const mdiIcons: Record<string, string> = {
	"mdi-account-alert-outline": mdiAccountAlertOutline,
	"mdi-account-group": mdiAccountGroup,
	"mdi-alert": mdiAlert,
	"mdi-alert-circle": mdiAlertCircle,
	"mdi-alert-circle-outline": mdiAlertCircleOutline,
	"mdi-arrow-collapse": mdiArrowCollapse,
	"mdi-arrow-expand": mdiArrowExpand,
	"mdi-arrow-expand-horizontal": mdiArrowExpandHorizontal,
	"mdi-arrow-left": mdiArrowLeft,
	"mdi-arrow-right": mdiArrowRight,
	"mdi-chat": mdiChat,
	"mdi-calendar-outline": mdiCalendarOutline,
	"mdi-check": mdiCheck,
	"mdi-check-circle": mdiCheckCircle,
	"mdi-check-circle-outline": mdiCheckCircleOutline,
	"mdi-chevron-down": mdiChevronDown,
	"mdi-chevron-left": mdiChevronLeft,
	"mdi-chevron-right": mdiChevronRight,
	"mdi-close": mdiClose,
	"mdi-close-circle-outline": mdiCloseCircleOutline,
	"mdi-cloud-off": mdiCloudOff,
	"mdi-code-tags": mdiCodeTags,
	"mdi-cog": mdiCog,
	"mdi-connection": mdiConnection,
	"mdi-content-copy": mdiContentCopy,
	"mdi-creation": mdiCreation,
	"mdi-database": mdiDatabase,
	"mdi-delete-outline": mdiDeleteOutline,
	"mdi-dots-vertical": mdiDotsVertical,
	"mdi-download": mdiDownload,
	"mdi-drag-vertical": mdiDragVertical,
	"mdi-earth": mdiEarth,
	"mdi-email-check-outline": mdiEmailCheckOutline,
	"mdi-email-outline": mdiEmailOutline,
	"mdi-eye": mdiEye,
	"mdi-eye-off": mdiEyeOff,
	"mdi-facebook": mdiFacebook,
	"mdi-file-chart-outline": mdiFileChartOutline,
	"mdi-file-delimited": mdiFileDelimited,
	"mdi-file-document-outline": mdiFileDocumentOutline,
	"mdi-file-pdf-box": mdiFilePdfBox,
	"mdi-file-word-box": mdiFileWordBox,
	"mdi-form-textbox": mdiFormTextbox,
	"mdi-format-bold": mdiFormatBold,
	"mdi-format-italic": mdiFormatItalic,
	"mdi-format-list-bulleted": mdiFormatListBulleted,
	"mdi-format-list-checks": mdiFormatListChecks,
	"mdi-format-list-numbered": mdiFormatListNumbered,
	"mdi-format-quote-close": mdiFormatQuoteClose,
	"mdi-format-underline": mdiFormatUnderline,
	"mdi-history": mdiHistory,
	"mdi-image": mdiImage,
	"mdi-image-outline": mdiImageOutline,
	"mdi-image-size-select-actual": mdiImageSizeSelectActual,
	"mdi-instagram": mdiInstagram,
	"mdi-linkedin": mdiLinkedin,
	"mdi-link-variant": mdiLinkVariant,
	"mdi-lock": mdiLock,
	"mdi-magnify": mdiMagnify,
	"mdi-magnify-plus-outline": mdiMagnifyPlusOutline,
	"mdi-message-text-outline": mdiMessageTextOutline,
	"mdi-microsoft-excel": mdiMicrosoftExcel,
	"mdi-minus-circle-outline": mdiMinusCircleOutline,
	"mdi-package-variant": mdiPackageVariant,
	"mdi-package-variant-remove": mdiPackageVariantRemove,
	"mdi-pencil": mdiPencil,
	"mdi-phone-outline": mdiPhoneOutline,
	"mdi-play-circle-outline": mdiPlayCircleOutline,
	"mdi-plus": mdiPlus,
	"mdi-plus-circle": mdiPlusCircle,
	"mdi-printer": mdiPrinter,
	"mdi-redo": mdiRedo,
	"mdi-refresh": mdiRefresh,
	"mdi-measure-stroke": measureStroke,
	"mdi-sort": mdiSort,
	"mdi-star": mdiStar,
	"mdi-star-outline": mdiStarOutline,
	"mdi-sync": mdiSync,
	"mdi-tag-outline": mdiTagOutline,
	"mdi-table-column-plus-after": mdiTableColumnPlusAfter,
	"mdi-table-column-remove": mdiTableColumnRemove,
	"mdi-table-plus": mdiTablePlus,
	"mdi-timer-sand": mdiTimerSand,
	"mdi-translate": mdiTranslate,
	"mdi-table-row-plus-after": mdiTableRowPlusAfter,
	"mdi-table-row-remove": mdiTableRowRemove,
	"mdi-trash-can-outline": mdiTrashCanOutline,
	"mdi-undo": mdiUndo,
	"mdi-crosshairs-gps": mdiCrosshairsGps,
	"mdi-map-marker": mdiMapMarker,
	"mdi-map-marker-outline": mdiMapMarkerOutline,
	"mdi-account-outline": mdiAccountOutline,
	"mdi-video-outline": mdiVideoOutline,
	"mdi-view-grid": mdiViewGrid,
	"mdi-share-variant": mdiShareVariant,
	"mdi-image-multiple": mdiImageMultiple,
	"mdi-music-note": mdiMusicNote,
	"mdi-open-in-new": mdiOpenInNew,
	"mdi-twitter": mdiTwitter,
	"mdi-web": mdiWeb,
	"mdi-youtube": mdiYoutube
};
